import initCursor from "./components/cursor";
import initToggle from "./components/toggle";
import initTabs from "./components/tabs";
import initModal from "./components/modal";
import initCarousel from "./components/carousel";
import initContactMap from "./components/map";
import initScrollToTop from "./components/scroll-to-top";

//import "swiper/swiper-bundle.css";
import Swiper, { Navigation, Pagination } from "swiper";

initCursor();
initToggle();
initTabs();
initModal();
initCarousel();
initContactMap();
initScrollToTop();

(function () {
  const menuItems = document.querySelectorAll(
    ".mobile-nav .menu-item-has-children > a"
  );
  if (!menuItems || menuItems.length <= 0) {
    return;
  }
  menuItems.forEach((item) => {
    item.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        item.classList.toggle("is-open");
      },
      false
    );
  });
})();

(function () {
  const dropdownLinks = document.querySelectorAll(".main-nav .sub-menu a");
  if (!dropdownLinks || !dropdownLinks.length) {
    return;
  }

  function removeOpacity(e) {
    const submenu = e.target.closest(".sub-menu");
    if (submenu) {
      submenu
        .querySelectorAll("a")
        .forEach((item) => item.classList.remove("opacity-50"));
    }
  }

  function addOpacity(e) {
    const submenu = e.target.closest(".sub-menu");
    if (submenu) {
      submenu
        .querySelectorAll("a")
        .forEach((item) => item.classList.add("opacity-50"));
      this.classList.remove("opacity-50");
    }
  }

  dropdownLinks.forEach((item) => {
    item.addEventListener("mouseenter", addOpacity.bind(item), false);
    item.addEventListener("focus", addOpacity.bind(item), false);

    item.addEventListener("mouseleave", removeOpacity, false);
    item.addEventListener("blur", removeOpacity, false);
  });
})();

(function () {
  const backButtons = document.querySelectorAll(".js-back");
  const sameDomain = document.referrer.indexOf(window.location.host) !== -1;
  if (backButtons && sameDomain) {
    backButtons.forEach((button) => button.classList.remove("hidden"));
  }
})();

(function () {
  const modalIframes = document.querySelectorAll(
    ".block-gallery iframe,.block-gallery-narrow iframe"
  );
  if (!modalIframes.length) {
    return;
  }

  var tag = document.createElement("script");
  tag.id = "iframe-demo";
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onYouTubeIframeAPIReady = function () {
    modalIframes.forEach((iframe) => {
      iframe.ytPlayer = new YT.Player(iframe, {});
    });
  };
})();

(function () {
  const accordions = document.querySelectorAll(".accordion");
  if (!accordions || accordions.length == 0) {
    return;
  }

  accordions.forEach((accordion) => {
    const buttons = accordion.querySelectorAll("*[aria-controls]");

    function closeAllPanels() {
      buttons.forEach((button) => {
        const panel = document.querySelector(
          "#" + button.getAttribute("aria-controls")
        );
        panel.classList.add("hidden");
        button.setAttribute("aria-expanded", "false");
        button.classList.remove("is-open");
      });
    }

    buttons.forEach((button) => {
      button.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          const isOpen =
            button.getAttribute("aria-expanded") == "true" ? true : false;
          const panel = document.querySelector(
            "#" + button.getAttribute("aria-controls")
          );

          if (isOpen) {
            panel.classList.add("hidden");
            button.setAttribute("aria-expanded", "false");
            button.classList.remove("is-open");
          } else {
            closeAllPanels();
            panel.classList.remove("hidden");
            button.setAttribute("aria-expanded", "true");
            button.classList.add("is-open");
          }
        },
        false
      );
    });
  });
})();

(function () {
  const headerElement = document.querySelector(".header");
  if (!headerElement) {
    return;
  }

  let lastScrollTop = window.scrollY;

  function updateHeader() {
    const scrollTop = window.scrollY;
    const isDesktop = window.innerWidth > 768;
    const isFixed =
      (isDesktop && scrollTop > 100) || (!isDesktop && scrollTop > 100);

    if (
      isFixed &&
      scrollTop < lastScrollTop &&
      scrollTop > lastScrollTop - 100
    ) {
      return;
    }

    function toggleClasses() {
      if (isFixed && scrollTop > lastScrollTop) {
        headerElement.classList.add("is-hidden");
      }
      if ((isFixed && scrollTop < lastScrollTop - 60) || !isFixed) {
        headerElement.classList.remove("is-hidden");
      }

      headerElement.classList.toggle("is-fixed", isFixed);
    }

    toggleClasses();
    lastScrollTop = scrollTop;
  }
  window.addEventListener(
    "scroll",
    (e) => {
      updateHeader();
    },
    false
  );

  updateHeader();
})();

(function () {
  const backToTopButton = document.querySelector(".back-to-top");
  if (!backToTopButton) {
    return;
  }
  backToTopButton.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    false
  );
})();

(function () {
  // Conters
  const counters = document.querySelectorAll(".js-counter");

  const updateCount = (counterElement) => {
    const target = +counterElement.getAttribute("data-target");
    const count = +counterElement.innerText;
    const speed = 4000; // change animation speed here
    const inc = target / speed;
    if (count < target) {
      counterElement.innerText = Math.ceil(count + inc);
      setTimeout(() => {
        updateCount(counterElement);
      }, 1);
    } else {
      counterElement.innerText = target;
    }
  };

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  document.addEventListener(
    "scroll",
    function () {
      for (let counter of counters) {
        if (isInViewport(counter) && !counter?.animated) {
          counter.animated = true;
          updateCount(counter);
        }
      }
    },
    {
      passive: true,
    }
  );
})();

(function () {
  const contacts = document.querySelectorAll('.contact');
  contacts.forEach(contact => {
    const contactImage = contact.querySelector('.contact-image');
    const hoverImage = contact.querySelector('.contact-image-hover');
    if (hoverImage) {
      contact.addEventListener('mouseenter', e => {
        contactImage.classList.add('hidden');
        hoverImage.classList.remove('hidden');
      })

      contact.addEventListener('mouseleave', e => {
        contactImage.classList.remove('hidden');
        hoverImage.classList.add('hidden');
      })
    }
  })
})();
